
const RuleBasedToAgenticSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-20">
            <div className="space-y-8">
              <h2 className="text-4xl md:text-5xl font-bold leading-tight">
                From Rule-Based Playbooks to 
                <span className="bg-gradient-to-r from-[#8932c8] to-[#b87ade] bg-clip-text text-transparent"> Agentic Intelligence</span>
              </h2>
              <div className="space-y-6">
                <p className="text-xl text-gray-700 leading-relaxed">
                  The role of agentic AI within the MSSP context is transformative. The agent is goal-driven with 
                  autonomous decision-making capabilities.
                </p>
                <p className="text-lg text-gray-600 leading-relaxed">
                  It can take initiative, remember context, and make multi-step decisions at scale. By contrasting 
                  this with traditional SOAR playbooks and LLM chatbots that many MSSPs still use today, you can 
                  begin to see how Aura XP agents can transform an MSSP through intelligent, context-aware responses.
                </p>
              </div>
            </div>
            
            <div className="flex justify-center">
              <img 
                src="/lovable-uploads/7360830c-0e0f-460c-a4e0-297f801dd9a7.png"
                alt="Cybersecurity professional analyzing threats"
                className="w-full h-auto rounded-2xl shadow-2xl max-w-lg"
              />
            </div>
          </div>
          
          <div className="bg-gradient-to-r from-white to-slate-50 rounded-3xl shadow-xl border border-gray-200 p-8 md:p-12">
            <h3 className="text-3xl font-bold mb-10 text-center">Key Transformation Areas</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100">
                <h4 className="text-xl font-bold mb-4">Real-Time Decision Making</h4>
                <p className="text-gray-600 leading-relaxed">Aura XP evaluates signals in real-time and initiates remediation without waiting for human input</p>
              </div>
              
              <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100">
                <h4 className="text-xl font-bold mb-4">Context Awareness</h4>
                <p className="text-gray-600 leading-relaxed">Asks "Is this normal for this user on this day?" before taking action</p>
              </div>
              
              <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100">
                <h4 className="text-xl font-bold mb-4">Reduced Alert Fatigue</h4>
                <p className="text-gray-600 leading-relaxed">Intelligent filtering reduces false positives by 80% for more satisfied clients</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RuleBasedToAgenticSection;
